import nsdcLogo from '@assets/branding/nsdc-trust.svg';
import trentialWithText from '@assets/branding/trential-with-text.svg';
import OrgWithTrentialBranding from '@auth/custom/dynamic/org-with-trential-branding';
import { Box, Stack, SxProps, Typography } from '@mui/material';
import { RootState } from '@redux/store';
import { useSelector } from 'react-redux';

const nsdcPartner = import.meta.env.VITE_NSDC_PARTNER ?? '';
const showNSDCBranding = nsdcPartner;

function Branding() {
  const auth: any = useSelector((s: RootState) => s.auth);
  const { accessToken } = auth;

  const getBrandingImg = () => {
    let imgStyle: SxProps = {
      height: { xs: '2rem', md: '2.5rem' },
      width: 'auto',
      margin: '.5rem 1rem'
    };
    let src = trentialWithText;
    let alt = 'Trential Logo';
    if (showNSDCBranding) {
      src = nsdcLogo;
      alt = 'NSDC Trust Logo';
      imgStyle = {
        ...imgStyle,
        height: { xs: '5rem' }
      };
    }
    return {
      src,
      alt,
      style: imgStyle
    };
  };

  const img = getBrandingImg();

  return (
    <>
      {import.meta.env.VITE_SHOW_TRENTIAL_BRANDING && (
        <>
          {!accessToken && <OrgWithTrentialBranding size="large" />}
          {accessToken && (
            <Box
              component={'button'}
              sx={{
                all: 'unset',
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
              <Box component={'img'} src={img?.src} alt={img?.alt} sx={img?.style} />
              {showNSDCBranding && (
                <Stack>
                  <Typography sx={{ fontWeight: '700', color: '#000' }}>
                    National Skill Development Corporation
                  </Typography>
                </Stack>
              )}
            </Box>
          )}
        </>
      )}
    </>
  );
}
export default Branding;
